var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"light-theme"},[_c('v-main',{staticClass:"theme-background theme-purple-background"},[_c('v-container',{staticClass:"no-gutters pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }